import React, { useEffect, useState } from 'react';
import { Select, Row, Col, Checkbox, message, Form } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { getConfig } from '../../utils/config';
import { taApiClient } from '../../utils/http-client';
import BaseForm from '../base/form.base';
import './antd.form.css';
import patterns from '../../config/patterns';
import { scrollUp } from '../../utils/scroll-to';
import { PhoneInput } from '../phone-input/phone-input';
import { ButtonType, TAButton, TAInput, TAPasswordInput } from '../widgets';

let { phoneNumberPattern } = patterns;
const config = getConfig();
// const providers = config.auth_providers

export const InvitationSignupForm: React.FC<any> = ({ invitationToken, callback, style, email }) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [errors, setErrors] = useState<any>();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	useEffect(() => {
		form.setFieldsValue({ email });
	}, [email]);

	const onFinish = async values => {
		setLoading(true);
		if (values.contact.phoneNumber?.phone)
			values.contact.phoneNumber = `${values.contact.phoneNumber.code}-${values.contact.phoneNumber.phone}`;

		let response;
		try {
			response = await taApiClient.post(config.URIs.invitation_signup, { ...values, invitationToken });
			let responseOK = response && Math.round(response.status / 100) === 2;
			if (!responseOK) throw new Error('Network Error, Please contact support for help.');
		} catch (e: any) {
			setErrors({ ...errors, ...(e.errors || {}) });
			return;
		} finally {
			setLoading(false);
			callback && callback(response.data.token, response.data.profile);
			navigate('/dashboard');
		}
	};
	const checkIfEqualFirstPassword = (rule, value) => {
		if (value && value !== form.getFieldValue(['account', 'password']))
			return Promise.reject('Two passwords that you entered are inconsistent!');
		return Promise.resolve();
	};

	// const checkIfEqualConfirmationPassword = (rule, value) => {
	// 	if (value) {
	// 		return form.validateFields(['account', 'confirmPassword']);
	// 	}
	// 	return Promise.resolve();
	// };

	const checkAgreement = (rule, value, callback) => {
		if (!value) callback('you must agree to our terms to proceed.');
		else callback();
	};

	return (
		<Form layout="vertical" onFinish={onFinish} form={form} className="ta-form" style={style}>
			<legend className="ta-form-section-title">Account information</legend>
			<Row gutter={8}>
				<Col xs={12} md={24}>
					<Form.Item
						label="First Name"
						name={['contact', 'firstName']}
						rules={[
							{
								required: true,
								message: 'Please input your first name.'
							},
							{ pattern: patterns.lettersOnlyPattern, message: 'Not valid name' }
						]}
					>
						<TAInput />
					</Form.Item>
				</Col>
				<Col xs={12} md={24}>
					<Form.Item
						label="Last Name"
						name={['contact', 'lastName']}
						rules={[
							{ required: true, message: 'Please enter last name.' },
							{ pattern: patterns.lettersOnlyPattern, message: 'Not valid name' }
						]}
					>
						<TAInput />
					</Form.Item>
				</Col>
			</Row>
			<Form.Item
				label="Title"
				name={['contact', 'title']}
				rules={[{ required: true, message: 'Please enter your title.' }]}
			>
				<TAInput />
			</Form.Item>

			<Form.Item
				label="Phone"
				name={['contact', 'phoneNumber']}
				rules={[
					{ required: true, message: ' ' },
					{
						validator: (rule, value, callback) => {
							if (!value || !value.code || !value.phone) {
								callback('Phone number should be added');
							} else if (value.phone && !phoneNumberPattern.test(value.phone)) {
								callback('Not valid phone number');
							} else callback();
						}
					}
				]}
			>
				<PhoneInput />
			</Form.Item>

			<Form.Item label="Email" name="email">
				<TAInput disabled />
			</Form.Item>

			<Form.Item
				label="Password"
				name={['account', 'password']}
				rules={[
					{ required: true, message: 'Please enter password.' },
					{
						pattern: patterns.passwordPattern,
						message: (
							<p style={{ marginBottom: '1px' }}>
								Password must contain at least 8 characters including at least one alphabet and one
								number and no spaces
							</p>
						)
					}
					// { validator: checkIfEqualConfirmationPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item
				label="Confirm Password"
				name={['account', 'confirmPassword']}
				rules={[
					{
						required: true,
						message: 'Please enter password confirmation.'
					},
					{ validator: checkIfEqualFirstPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item name="agreement" valuePropName="checked" rules={[{ validator: checkAgreement }]}>
				<Checkbox className="ta-checkbox w-100">
					I agree on talents arena{' '}
					<Link to="/terms-of-use" target="_blank">
						terms of use
					</Link>
					.
				</Checkbox>
			</Form.Item>
			<Form.Item>
				<TAButton
					htmlType="submit"
					btntype={ButtonType.PRIMARY}
					style={{
						width: '100%',
						padding: '.8rem 0.8rem',
						borderRadius: '.9rem',
						fontSize: '.9rem',
						fontWeight: 500,
						lineHeight: '1.36',
						height: 'auto'
					}}
					loading={loading}
				>
					Sign Up
				</TAButton>
			</Form.Item>
		</Form>
	);
};
